module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"ReportArticles":"","Events":"イベント","IndividualMatches":"歩数戦","TeamMatches":"歩数戦","関連コンテンツ":"関連コンテンツ","こちらもおすすめ":"こちらもおすすめ"},"en":{"ReportArticles":"","Events":"Events","IndividualMatches":"Step competitions","TeamMatches":"Step competitions","関連コンテンツ":"Related Contents","こちらもおすすめ":"Recommended Contents"}}')
  delete Component.options._Ctor
}
